import React, { useEffect, useState } from "react";
import WithLoginLayout from "../../../Layout/withLoginLayout";
import {
  Typography,
  Stack,
  styled,
  InputBase,
  FormControl,
  InputLabel,
  Button,
  Checkbox,
  Box,
  Divider,
  Tooltip,
  TooltipProps,
  tooltipClasses,
  IconButton,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { BootstrapInput } from "../../../SharedComponents/inputComponents";

import tooltipInfo from "../../../assets/images/tooltip/tooltip_info.png";
import { getPageIdentifier } from "../../../Utils/pageIdentifier";
import "./index.css";
import {
  validateAccountNumber,
  phoneNumberRegex,
  formatPhoneNumberInput,
  emailRegex,
  accountNumberRegex,
} from "../../../Utils/validations-utils";
import { toast } from "react-toastify";
import ToastCustonIcon from "../../../SharedComponents/toastCustomIcons";
import {
  fetchAccountInfoForAgent,
  fetchAccountInfoWithBan,
} from "../../../../../shared/hooks/useFetchAccountInfo";
import API_URLS from "../../../../../shared/utils/ApiUrls";
import store from "../../../SharedContextStore/store";
import useBrightspeedHeaders from "../../../hooks/useBrightspeedHeader";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { getBrightspeedToken, setHeaders } from "../../../SharedContextStore/slices/brightspeedToken";
import {
  CONST_VALUES,
  webRefreshTokenRedux,
} from "../../../../../shared/utils/Constants";
import {
  addUserCustomerId,
  getUserDetailsForAgent,
  logout,
  startLoading,
  stopLoading,
} from "../../../SharedContextStore/slices/user";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { unifiedLoginWithMobileNumber } from "../../../../../shared/hooks/useFetchCompleteAddress";
import {
  getAzureInfo,
  getUserAccNoAndZipcode,
} from "../../../../../shared/hooks/useFetchLogin";
import AlreadyOnPaymentSchedule from "./AlreadyOnPaymentSchedule";
import {
  getNonAuthPaymentArrangement,
  setFetchPlan,
  setIsModalVisible,
  setIsUserIneligible,
  setPaymentIssueModalUserData,
  setPlanDetails,
  updateCallBackUrlAfterNonAuthValidateOTP,
  updateIsNonAuthPa,
  updateNonAuthEmailId,
  updateNonAuthPrincipalName,
} from "../../../SharedContextStore/slices/non-auth-paymentArrangement";
//import QBPBillPending from "./QBPBillPending";
import { getnotEligibleQBPPaymentContent } from "../../../SharedContextStore/slices/notEligibleQBPAem";
import { formatDateWithOffset, replaceJSX } from "../../../Utils/utils";
import PrepayAccount from "./PrepayAccount";
import AccountDisconnected from "./AccountDisconnected";
import IssueWithPayments from "./IssueWithPayments";
import BSDialog from "./BSDialog";
import { getPaymentHistoryForPA } from "../../../SharedContextStore/slices/paymentHistoryForPA";
import{ DialogProps } from '@mui/material/Dialog';
import DwLogutil from "../../../Utils/DwLogutil";
import { EC_DW_LOGGING_STEPS } from "../../../../../shared/utils/Constants";
import { NotEligibleForPaymentArrangements } from "../../../SharedComponents/contents";
import { setMigrated } from "../../../SharedContextStore/slices/migrationCheck";
import { useCustomNavigate } from "../../../Utils/navigationUtils";
import { addEneventGTM } from "../../../Utils/googleTags";
import { resetUseUserSlice, setGTM_TagTriggerFor } from "../../../SharedContextStore/slices/brightSpeedUserUtils";
import { clearNextPaymentDetailSlice } from "../../../SharedContextStore/slices/nextPaymentDetails";
import IssueWithAccountType from "./IssueWithAccountType";
import InvoicePending from "./InvoicePending";
import { resetAllBanners } from "../../../SharedContextStore/slices/notifications";

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#fff",
    color: "#000000",
    boxShadow: theme.shadows[5],
    borderRadius: 8,
    maxWidth: "none",
  },
}));

interface NonAuthProps {
  flow: string;
}

interface HelpLinkProps {
  label: string;
  href: string;
  internalLink?: boolean;
  title: string;
  link: string;
}

const NonAuthQBP = (props: NonAuthProps) => {
  const { customNavigate } = useCustomNavigate();
  const notEligibleForPaymentArrangements : any = NotEligibleForPaymentArrangements();
  const JSONcontent : any = notEligibleForPaymentArrangements?.entry;
  const PAJson = JSONcontent?.paymentArrangementLandingPage;
  const QBPJson = JSONcontent?.quickBillPayLandingPage;
  const {notEligiblePA, notEligibleDueToPaymentSchedule, formContents: formContentJSON, prePayAccount, accountDisconnected} = JSONcontent
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const headers = useBrightspeedHeaders();
  const globalToken = useAppSelector((state) => state?.brightspeedToken?.data);
  const { refreshToken } = useAppSelector((state) => state?.user);
  const {pathname, search} = useLocation();
  const [searchParams] = useSearchParams();
  const [isFormTidy, setIsFormTidy] = useState<boolean>(false)
  const {isModalVisible,paymentIssueModalUserData,isUserIneligible,planDetails,paFlag,fetchPlan} = useAppSelector(
    (state) => state?.nonAuthPaymentArrangement
  );
  const HelpLinks =
    props?.flow === "NON_AUTH_PAYMENT_ARRANGEMENTS"
      ? PAJson?.helpLinksForPA
      : QBPJson?.helpLinkForQBP;

  if(props?.flow === "NON_AUTH_PAYMENT_ARRANGEMENTS") {
    dispatch(updateIsNonAuthPa(true))
  }

  const { companyName, data: user, sessionId } = useAppSelector(state => ({
    companyName: state?.user?.companyName,
    data: state?.user?.data,
    sessionId: state?.user?.sessionId,
  }));
 
  const currentPage = getPageIdentifier();
  const paymentHistoryForPA= useAppSelector((state)=> state.paymentHistoryForPA);
  const [scroll, setScroll] = React.useState<DialogProps['scroll']>('body');
  const nonAuthQBPSchema = yup
  .object({
    accountNumber: yup
      .string()
      .required(`${formContentJSON?.accountNumberError}`)
      .matches(/^([A-Za-z0-9]{3,})$/, `${formContentJSON?.accountNumberError}`)
      .nullable(),
    zipcode: yup
      .string()
      .required(`${formContentJSON?.zipCodeError}`)
      .matches(/^[0-9]{5}(?:-[0-9]{4})?$/,`${formContentJSON?.zipCodeError}`)
      .nullable(),
  })
  .required();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    setError,
    trigger,
    formState: {isDirty, isValid, errors, isSubmitted },
  } = useForm({
    resolver: yupResolver(nonAuthQBPSchema),
    mode: "onBlur",
    defaultValues: {
      accountNumber: "",
      zipcode: "",
    },
  });

  const dwLogDefaultProps = {headers, sessionId, email: user?.email, companyName}
  useEffect(() => {
    dispatch(getnotEligibleQBPPaymentContent());
    if(headers?.Authorization){
      DwLogutil({
      ...dwLogDefaultProps, 
      stepName: props?.flow === "NON_AUTH_QBP" 
                ? EC_DW_LOGGING_STEPS?.lp_unauthqbp_user_stepped
                : EC_DW_LOGGING_STEPS?.lp_pa_user_stepped
    })
    addEneventGTM(
      props?.flow === "NON_AUTH_QBP" 
                ? EC_DW_LOGGING_STEPS?.lp_unauthqbp_user_stepped
                : EC_DW_LOGGING_STEPS?.lp_pa_user_stepped,
      sessionId,
      user?.billingAccountNumber,
      companyName
    )
    addEneventGTM(
      props?.flow === "NON_AUTH_QBP" 
      ? EC_DW_LOGGING_STEPS?.lp_unauthqbp_user_stepped
      : EC_DW_LOGGING_STEPS?.lp_pa_user_stepped,
      sessionId,
      user?.billingAccountNumber,
      companyName
    )
  }}, [headers?.Authorization]);

  useEffect(() => {
    handleClickOpen('body');
    dispatch(logout());
    dispatch(resetAllBanners());
    dispatch(clearNextPaymentDetailSlice())
    dispatch(resetUseUserSlice());
    dispatch(setGTM_TagTriggerFor(""));
    dispatch(addUserCustomerId(""));
    if (!refreshToken && headers?.["refresh-token"]) {
      const tempHeader = {...headers}
      delete tempHeader['refresh-token'];
      dispatch(
        setHeaders({
          ...tempHeader
        })
      );
    }
  }, []);

    const handleClickOpen = (scrollType: DialogProps['scroll']) => () => {
        setScroll(scrollType);
      };


  useEffect(() => {
    if (
      !globalToken?.access_token &&
      process.env.REACT_APP_ENV === "production"
    ) {
      const source = {
        refreshToken: async () => await dispatch(getBrightspeedToken()),
        webReduxStore: store,
      };
      Object.assign(webRefreshTokenRedux, source);
      getBrightSpeedTokenSync();
    }
  }, []);

  useEffect(() => {
    const accountNumber = watch('accountNumber');
    const zipCode = watch('zipcode')
    if( 
      accountNumber.match(/^([A-Za-z0-9]{3,})$/) 
      && zipCode.match(/^[0-9]{5}(?:-[0-9]{4})?$/)
    ) {
      setIsFormTidy(true);
    } else {
      setIsFormTidy(false);
    }
  }, [watch('accountNumber'), watch('zipcode')])

  const getBrightSpeedTokenSync = async () => {
    await dispatch(getBrightspeedToken());
  };
  const onSubmit = async (data: any) => {
    try {
      if (data?.accountNumber && data?.zipcode) {
        let body = {
          zipCode: data?.zipcode,
          ban: data?.accountNumber,
        };

        dispatch(startLoading());

        localStorage.setItem("headersSiteId","ctl");
        dispatch(
          setHeaders({
            ...headers,
            siteId: "ctl",
          })
        );
     
        // Parallel API calls using Promise.all
        let promises: Promise<any>[] = [
          getUserAccNoAndZipcode(
            {
              "": API_URLS?.paymetArrangemetUserValidateURL,
            },
            body,
            headers
          )
        ];
     
        if (currentPage !== "non-auth-quick-bill-pay") {
          promises.push(
            dispatch(getNonAuthPaymentArrangement(data?.accountNumber)),
            dispatch(getPaymentHistoryForPA(data?.accountNumber))
          );
        }
        const [response, fetchPlanResponse, paymentHistoryRes]: any = await Promise.all(promises);
       
        if(fetchPlanResponse?.payload){
          dispatch(setFetchPlan(fetchPlanResponse?.payload?.billDay))
        }
      
        dispatch(setPlanDetails(response))
        // If Account Not found or No Response 
        if ( !response?.data?.billingAccountNumber ) {
          setError("accountNumber", {
            message: `${formContentJSON?.cannotFindAccount}`,
          });
          toast.error(`${formContentJSON?.userDetailNotfound}`, { icon: <ToastCustonIcon type="error" /> });
          const stepName= (currentPage !== "non-auth-quick-bill-pay") 
            ? EC_DW_LOGGING_STEPS?.Pa_unAuth_ActNotFound
            : EC_DW_LOGGING_STEPS?.unauthqbp_actNotFound
          DwLogutil({headers, sessionId, email: user?.email, companyName, stepName, error: response.data.message})
          addEneventGTM(
            stepName,
            sessionId,
            user?.billingAccountNumber,
            companyName
          )
          return dispatch(stopLoading()); //Stop proceeding further
        }

        
        
        switch (true) {   
          // Enterprise in-eligible accounts condition
          case (currentPage !== "non-auth-quick-bill-pay" && response?.data?.billingType 
            && (response?.data?.accountType?.toUpperCase() === "ENTERPRISE" || response?.data?.accountType?.toUpperCase() === "WHOLESALE")):
              dispatch(setIsModalVisible("ENTERPRISE-ACCOUNT"));
              const stepNameEnterprise= (currentPage !== "non-auth-quick-bill-pay") 
            ? (response?.data?.accountType?.toUpperCase() === "ENTERPRISE") ? EC_DW_LOGGING_STEPS?.Pa_ineligible_landing_enterprise_account_modal 
            : EC_DW_LOGGING_STEPS?.Pa_ineligible_landing_wholesale_account_modal
            : EC_DW_LOGGING_STEPS?.unauthqbp_LP_enterprise_account
              DwLogutil({ headers, sessionId, email: user?.email, companyName, stepName:stepNameEnterprise });
              dispatch(stopLoading());
              addEneventGTM(
                stepNameEnterprise,
                sessionId,
                user?.billingAccountNumber,
                companyName
              );
              return;  // Exit the function immediately if DISCONNECTED

          //. Prepay in-eligible accounts condition
          case !(response?.data?.billingType && response?.data?.billingType?.toUpperCase() === "POSTPAID"):
              dispatch(setIsModalVisible("PREPAY-ACCOUNT"));
              const stepNamePrePay= (currentPage !== "non-auth-quick-bill-pay") 
            ? EC_DW_LOGGING_STEPS?.Pa_ineligible_landing_prepay_account_modal
            : EC_DW_LOGGING_STEPS?.unauthqbp_LP_prepay_account
              DwLogutil({ headers, sessionId, email: user?.email, companyName, stepName:stepNamePrePay });
              dispatch(stopLoading());
              addEneventGTM(
                stepNamePrePay,
                sessionId,
                user?.billingAccountNumber,
                companyName
              );
              return;  // Exit the function immediately if DISCONNECTED
          
          //. DISCONNECTED condition (Checking account status)
          case !response?.data?.currentStatus ||
              ["INACTIVE", "IN-ACTIVE", "PENDING", "PENDING DISCONNECTED"]?.includes(response?.data?.currentStatus?.toUpperCase()):
              dispatch(setIsModalVisible("DISCONNECTED"));
              const stepNameDisconnect=(currentPage !== "non-auth-quick-bill-pay") 
              ? EC_DW_LOGGING_STEPS?.Pa_ineligible_landing_INACTIVE_account_modal
              : EC_DW_LOGGING_STEPS?.unauthqbp_LP_account_disconnected
              DwLogutil({ headers, sessionId, email: user?.email, companyName, stepName:stepNameDisconnect });
              addEneventGTM(
                stepNameDisconnect,
                sessionId,
                user?.billingAccountNumber,
                companyName
              );
              dispatch(stopLoading());  // Stop further processing
              return;  // Exit the function immediately if DISCONNECTED
              
          //. Fetch Plan API Failing
          case fetchPlanResponse?.error && currentPage !== "non-auth-quick-bill-pay":
            DwLogutil({ headers, sessionId, email: user?.email, companyName, stepName:EC_DW_LOGGING_STEPS?.Pa_fetch_plan_failure });
              dispatch(stopLoading());
              addEneventGTM(
                EC_DW_LOGGING_STEPS?.Pa_ineligible_landing_enterprise_account_modal,
                sessionId,
                user?.billingAccountNumber,
                companyName
              );
              toast.error("Something Went wrong. Please try again later.", { icon: <ToastCustonIcon type="error" /> });
              return;  // Exit the function immediately if fetchplan fails
  
          // . Conditions only for PA (Payment Arrangement)
          case currentPage === "non-auth-payment-arrangement" && paymentHistoryRes?.payload?.treatment[0]?.installment.some(
          (item: any) => item?.status?.toUpperCase() === "FAILED"):
              dispatch(setPaymentIssueModalUserData(response?.data));
              dispatch(setIsModalVisible("PAYMENT-ISSUE"));
              const paymentIssueStepName = EC_DW_LOGGING_STEPS?.Pa_ineligible_landing_payment_issue_with_pa_modal;
              DwLogutil({ headers, sessionId, email: user?.email, companyName, stepName:paymentIssueStepName });
              addEneventGTM(
                paymentIssueStepName,
                sessionId,
                user?.billingAccountNumber,
                companyName
              );
              sessionStorage.setItem('ineligible',"true")
              if(paFlag){
                dispatch(stopLoading());
                return; // exit from the entire function
              }else{
                break; // Exit the switch, but continue to the rest of the code
              }
          //. Invoice Pending
          case fetchPlanResponse?.payload?.invoicing ==="X":
            dispatch(setIsModalVisible("INVOICE-PENDING"));
            const invoicePendingStepName = EC_DW_LOGGING_STEPS?.Pa_ineligible_invoice_pending;
            DwLogutil({ headers, sessionId, email: user?.email, companyName, stepName:invoicePendingStepName});
            addEneventGTM(
              invoicePendingStepName,
              sessionId,
              user?.billingAccountNumber,
              companyName
            );
            sessionStorage.setItem('ineligible',"true")
            if(paFlag){
              dispatch(stopLoading());
              return; // exit from the entire function
            }else{
              break; // Exit the switch, but continue to the rest of the code
            }

          case currentPage === "non-auth-payment-arrangement" && paymentHistoryRes?.payload?.treatment[0]?.installment !== undefined:
              sessionStorage.setItem("isPa", "true");
              sessionStorage.setItem('originUrl', "/non-auth-quick-bill-pay");
              dispatch(setIsModalVisible("ALREADY-APPLYED"));
              const alreadyAppliedStepName = EC_DW_LOGGING_STEPS?.Pa_ineligible_landing_already_in_pa_modal;
              DwLogutil({ headers, sessionId, email: user?.email, companyName, stepName:alreadyAppliedStepName });
              addEneventGTM(
                alreadyAppliedStepName,
                sessionId,
                user?.billingAccountNumber,
                companyName
              );
              sessionStorage.setItem('ineligible',"true")
              if(paFlag){
                dispatch(stopLoading());
                return; // exit from the entire function
              }else{
                break; // Exit the switch, but continue to the rest of the code
              }
               
        } 
        
        if (response?.data?.billingAccountNumber && response?.data?.addressId) {
          // Fetch user details and validate
          const accountDetails = await dispatch(getUserDetailsForAgent({ban: response?.data?.billingAccountNumber}));
     
          if (accountDetails?.payload?.email) {
              dispatch(updateNonAuthEmailId(accountDetails?.payload?.email));
     
              // Update callback URL based on flow
              if (props?.flow === "NON_AUTH_PAYMENT_ARRANGEMENTS") {
                dispatch(
                  updateCallBackUrlAfterNonAuthValidateOTP(
                    `/agent-payment-arrangements?accountId=${response?.data?.billingAccountNumber}&addressId=${response?.data?.addressId}`
                  )
                );
              } else if (props?.flow === "NON_AUTH_QBP") {
                dispatch(
                  updateCallBackUrlAfterNonAuthValidateOTP(
                    `/agent-quick-bill-pay?accountId=${response?.data?.billingAccountNumber}&addressId=${response?.data?.addressId}&flow=AMQBP`
                  )
                );
              }
     
              // Navigate to non-authentication validation page
              sessionStorage.setItem('isInitialAutoPayModalCall', 'true');
              sessionStorage.setItem("originUrl", `${pathname}${search}`);
              const paymentIssueStepName = EC_DW_LOGGING_STEPS?.Pa_ineligible_landing_payment_issue_with_pa_modal;
              customNavigate("/non-auth-validation");
            } else {
              setError("accountNumber", {
                message: `${formContentJSON?.cannotFindAccount}`,
              });
              toast.error(`${formContentJSON?.invalidUserError}`, { icon: <ToastCustonIcon type="error" /> });
            }
          }
        } else {
          setError("accountNumber", {
            message: `${formContentJSON?.cannotFindAccount}`,
          });
          toast.error(`${formContentJSON?.userDetailNotfound}`, { icon: <ToastCustonIcon type="error" /> });
          const stepName= (currentPage !== "non-auth-quick-bill-pay")
          ? EC_DW_LOGGING_STEPS?.Pa_unAuth_ActNotFound
          : EC_DW_LOGGING_STEPS?.unauthqbp_actNotFound
          DwLogutil({headers, sessionId, email: user?.email, companyName, stepName, error: 'error'})
        }
     
        dispatch(stopLoading());
    } catch (error) {
      dispatch(stopLoading());
      console.error(error);
      toast.error(`${formContentJSON?.fetchingDetailError}`, { icon: <ToastCustonIcon type="error" /> });
    }
  };

  const openLinkOnNewTab = (url: string) => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  const isMigrated = useAppSelector((state) => state.isMigrated.isMigrated);
  useEffect(() => {
    if(!isMigrated){
      const migrationCheck = searchParams.get('migratedCTL') === "Y";
      dispatch(setMigrated(migrationCheck));
    }
  }, []);

  return (
    <WithLoginLayout>
      <Stack className="OverallPage">
        <Stack className="loginMain">
          <>
            <Typography
              component="h1"
              className="title non-auth-QBP-page-title"
            >
              {props?.flow === "NON_AUTH_PAYMENT_ARRANGEMENTS"
                ? PAJson?.title
                : QBPJson?.title}
            </Typography>
            <Typography className="desc">
              {props?.flow === "NON_AUTH_PAYMENT_ARRANGEMENTS"
                ? PAJson?.subTitle
                : QBPJson?.subTitle}
            </Typography>
          </>
          <Stack className="userInputForm">
            <Stack className="userInputFormTop">
              <FormControl variant="standard">
                <InputLabel
                  shrink
                  htmlFor="accountNumber"                
                  className="modalBoxDescInput"
                >
                  {PAJson?.accountNoInputLabel}
                  <LightTooltip
                    enterTouchDelay={0}
                    title={
                      <Stack sx={{ p: "10px", width: "239px" }} gap="23px">
                        <Typography
                          sx={{ fontSize: "10px", lineHeight: "14px" }}
                        >
                          {replaceJSX(
                            PAJson
                              ?.accountNoToolTip,
                            "<VALUE>",
                            <b>{notEligibleDueToPaymentSchedule?.accountNumber}</b>
                          )}
                        </Typography>
                      </Stack>
                    }
                    arrow
                    placement="bottom"
                  >
                    <IconButton sx={{ p: 0, mt: "-2px", ml: "5px" }}>
                      <img alt="tooltip_info" src={tooltipInfo}></img>
                    </IconButton>
                  </LightTooltip>
                </InputLabel>
                <BootstrapInput
                  type="text"
                  defaultValue=""
                  className={`modalBoxDescInput ${errors?.accountNumber ? 'err-border' : ''}`}
                  id="accountNumber"  
                  aria-describedby="accnumber-error"               
                  {...register("accountNumber")}
                  placeholder={
                    PAJson
                      ?.accountNoPlaceholder
                  }
                  // inputProps={{ maxLength: 13 }}
                  inputProps={{
                    "aria-invalid":
                      errors && Object.keys(errors)?.includes("accountNumber") ? "true" : "false",
                    "aria-required": errors && Object.keys(errors)?.includes("accountNumber") ? "false" : "true",
                    maxLength: 13
                  }}
                  onKeyPress={(e: any) => {
                    if (!/[A-Za-z0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if(!e.target.value && e.key===' ') {//Prevents First space charac
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    setValue("accountNumber", e.target.value.trimStart());
                    if(isSubmitted) trigger('accountNumber')
                  }}
                />
                {errors?.accountNumber && (
                  <ErrorMessage
                    errors={errors}
                    name="accountNumber"
                    render={({ message }) => (
                      <Box className="errorMsgFormat"  id="accnumber-error">
                        <span className="inputFiledErrorImg"></span>
                        <span className="inputFiledErrorMsg">{message}</span>
                      </Box>
                    )}
                  />
                )}
              </FormControl>

              <FormControl variant="standard">
                <InputLabel
                  shrink
                  htmlFor="zipcode"
                  className="modalBoxDescInput"
                >
                  {
                    PAJson
                      ?.zipCodeInputLabel
                  }
                </InputLabel>
                <BootstrapInput
                  type="text"
                  defaultValue=""
                  id="zipcode"
                  aria-describedby="ZIPcode-error"
                  className={`modalBoxDescInput ${errors?.zipcode ? 'err-border' : ''}`}
                  // inputProps={{ maxLength: 5 }}
                  inputProps={{
                    "aria-invalid":
                      errors && Object.keys(errors)?.includes("zipcode") ? "true" : "false",
                    "aria-required": errors && Object.keys(errors)?.includes("zipcode") ? "false" : "true",
                    maxLength: 5
                  }}
                  {...register("zipcode")}
                  placeholder={
                    PAJson
                      ?.zipCodeInputplaceholder
                  }
                  onKeyPress={(e: any) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    setValue("zipcode", e.target.value);
                    if(isSubmitted) trigger('zipcode')
                  }}
                />
                {errors?.zipcode && (
                  <ErrorMessage
                    errors={errors}
                    name="zipcode"
                    render={({ message }) => (
                      <Box className="errorMsgFormat"  id="ZIPcode-error">
                        <span className="inputFiledErrorImg"></span>
                        <span className="inputFiledErrorMsg">{message}</span>
                      </Box>
                    )}
                  />
                )}
              </FormControl>
            </Stack>
            <Typography className="requiredLabel">{JSONcontent?.requiredLabel}</Typography>
          </Stack>
          <Box sx={{ mt: "40px" }}>
            <Button
              disabled={ !(isFormTidy && Object.keys(errors).length === 0) }
              variant="contained"
              className="rightBtn disabled"
              sx={{ ml: 0 }}

              onClick={
                handleSubmit(onSubmit)
              }
            >
              {PAJson?.submitBtn}
            </Button>
          </Box>
          <Divider className="logindivider" role="presentation"/>
          <Stack className="loginbottomSections">
            <Box className="needHelp">
              <Typography className="title" component="h2">
                {PAJson?.helpLabel}
              </Typography>
              {HelpLinks?.map((item: HelpLinkProps, index: number) => {
                return (
                  <Typography component="a"
                  href="javascript:"
                    key={index}
                    onClick={() => {
                      if (item?.internalLink) {
                        customNavigate(item?.href);
                      } else {
                        openLinkOnNewTab(item?.href);
                      }
                       const stepName=(currentPage !== "non-auth-quick-bill-pay") 
                       ?`${EC_DW_LOGGING_STEPS?.Pa_landing_page_links_clicked} - ${item?.label}`
                       :`${EC_DW_LOGGING_STEPS?.unauthqbp_LP_links_clicked} - ${item?.label}`
                       DwLogutil({headers, sessionId, email: user?.email, companyName, stepName })
                    }}
                  >
                    {item?.label}
                  </Typography>
                );
              })}
            </Box>
          </Stack>
        </Stack>
        <BSDialog
          open={isModalVisible ==="ENTERPRISE-ACCOUNT" }
          onClose={() => dispatch(setIsModalVisible(""))}
          curveModal={true}
          showCloseIcon={true}
          curvedBorder="curvedModal"
        >
          <IssueWithAccountType onClose={() => dispatch(setIsModalVisible(""))} />
        </BSDialog>
        <BSDialog
          open={paFlag ? isModalVisible ==="PAYMENT-ISSUE" : isModalVisible === "PAYMENT-ISSUE" && isUserIneligible}
          onClose={() =>{
            dispatch(setIsModalVisible(""))
            dispatch(setIsUserIneligible(false))
          }} 
          curveModal={true}
          showCloseIcon={true}
          curvedBorder="curvedModal"
        >
          <IssueWithPayments
            billingAccountNumber={
              paymentIssueModalUserData?.billingAccountNumber
            }
            addressId={paymentIssueModalUserData?.addressId}
            planDetials={planDetails}
            onClose={() =>{
              dispatch(setIsModalVisible(""))
              dispatch(setIsUserIneligible(false))
            }} 
          />
        </BSDialog>
        <BSDialog
          open={isModalVisible === "DISCONNECTED"}
          onClose={() => dispatch(setIsModalVisible(""))}
          curveModal={true}
          showCloseIcon={true}
          curvedBorder="curvedModal"
        >
          <AccountDisconnected onClose={() => dispatch(setIsModalVisible(""))} />
        </BSDialog>
        <BSDialog
          open={isModalVisible === "PREPAY-ACCOUNT" }
          onClose={() => dispatch(setIsModalVisible(""))}
          curveModal={true}
          showCloseIcon={true}
          curvedBorder="curvedModal"
        >
          <PrepayAccount onClose={() => dispatch(setIsModalVisible(""))} />
        </BSDialog>
        <BSDialog
          open={paFlag ? isModalVisible === "INVOICE-PENDING" : isModalVisible === "INVOICE-PENDING" && isUserIneligible}
          onClose={() => {
            dispatch(setIsModalVisible(""))
            dispatch(setIsUserIneligible(false))
          }}
          curveModal={true}
          showCloseIcon={true}
          curvedBorder="curvedModal"
        >
          <InvoicePending date={fetchPlan} 
               onClose={() => {
                dispatch(setIsModalVisible(""))
                dispatch(setIsUserIneligible(false))
              }}
                />
        </BSDialog>
        <BSDialog
          open={paFlag ? isModalVisible === "ALREADY-APPLYED" : isModalVisible === "ALREADY-APPLYED" && isUserIneligible}
          scroll={scroll}
          onClose={() => {
             dispatch(setIsModalVisible(""))
             dispatch(setIsUserIneligible(false))
          }}
          
          curveModal={true}
          showCloseIcon={true}
          curvedBorder="curvedModal"
        >
          <AlreadyOnPaymentSchedule  planDetials={planDetails} onClose={
            () =>{
              dispatch(setIsModalVisible(""))
              dispatch(setIsUserIneligible(false))

            }} />
        </BSDialog>
      </Stack>
    </WithLoginLayout>
  );
};

export default NonAuthQBP;
